import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'

import { useEntitiesContext } from 'entities/EntitiesExport'
import { WidgetChatStore } from 'pages/settings/pages/widgetChat/store/WidgetChatStore'

const WidgetChatContext = createContext<WidgetChatStore | null>(null)

export const useWidgetChatContext = () => {
  const context = useContext(WidgetChatContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with WidgetChatProvider')

  return context
}

export const WidgetChatProvider = ({ children }: PropsWithChildren) => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new WidgetChatStore(entities), [])

  useEffect(() => store.dispose, [])

  return <WidgetChatContext.Provider value={store}>{children}</WidgetChatContext.Provider>
}
